import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'vsf-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationComponent {
  @Input() totalResults = 0;
  @Input() currentPage = 1;
  @Input() pageSize = 25;
  @Input() pageSizeOptions: number[] = [5, 10, 25, 50, 100];
  @Input() maxPagesToShow = 5;

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  get totalPages(): number {
    if (this.totalResults <= 0 || this.pageSize <= 0) {
      return 1;
    }
    return Math.max(1, Math.ceil(this.totalResults / this.pageSize));
  }

  get canGoPrevious(): boolean {
    return this.currentPage > 1;
  }

  get canGoNext(): boolean {
    return this.currentPage < this.totalPages;
  }

  get pageNumbers(): number[] {
    const totalPages = this.totalPages;
    const maxPagesToShow = this.maxPagesToShow;
    let startPage = Math.max(
      1,
      this.currentPage - Math.floor(maxPagesToShow / 2),
    );
    const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    const pages: number[] = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }

  goToFirst() {
    this.emitPage(1);
  }

  goToPrevious() {
    this.emitPage(this.currentPage - 1);
  }

  goToNext() {
    this.emitPage(this.currentPage + 1);
  }

  goToLast() {
    this.emitPage(this.totalPages);
  }

  goToPage(page: number) {
    this.emitPage(page);
  }

  onPageSizeChange(value: string | number) {
    const size = Number(value);
    if (!Number.isFinite(size) || size <= 0 || size === this.pageSize) {
      return;
    }
    this.pageSizeChange.emit(size);
  }

  private emitPage(page: number) {
    if (page < 1 || page > this.totalPages || page === this.currentPage) {
      return;
    }
    this.pageChange.emit(page);
  }
}
